import { updatePlanningFilters, setKeyFilterSelected } from "../../../redux/actions/planningActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filter";

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.planning.filters ? state.planning.filters[ownProps.filterTargetKey] : [],
    currentFilters: state.planning.currentFilters ? state.planning.currentFilters[ownProps.filterTargetKey] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder,
    mode: ownProps.mode,
    maxItemsToDisplay: 1000
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updatePlanningFilters(ownProps.filterTargetKey, values));
    },

    setKeyFilterSelected: () => dispatch(setKeyFilterSelected(ownProps.filterTargetKey))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);



// WEBPACK FOOTER //
// src/containers/activite/planning/FilterContainerType.js